import React from 'react';
import {Switch, Route, Router} from 'react-router-dom';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {Message} from 'semantic-ui-react';
import Layout from './components/Layout';

const selectedLocale = navigator.language.substring(0, 2);

const AppLinks = [
  {
    title: 'SsaForm',
    link: '/',
  },
];

const messages = {
  en: {
    SUPPLIER_MANAGEMENT_END_OF_LIFE_HEADER: 'You found a loose end',
    SUPPLIER_MANAGEMENT_END_OF_LIFE_BODY:
      'The supplier registration process for Horsch is no longer handled through this portal. Horsch will notify suppliers as soon as possible.',
    GENERAL_LANG_GERMAN: 'German',
    GENERAL_LANG_ENGLISH: 'English',
  },
  de: {
    SUPPLIER_MANAGEMENT_END_OF_LIFE_HEADER: 'Hinweis zur Einstellung',
    SUPPLIER_MANAGEMENT_END_OF_LIFE_BODY:
      'Der Lieferantenregistrierungsprozess für Horsch wird nicht mehr über dieses Portal abgewickelt. Horsch wird Lieferanten informieren sobald es weitere Informationen gibt.',
    GENERAL_LANG_GERMAN: 'Deutsch',
    GENERAL_LANG_ENGLISH: 'Englisch',
  },
}[selectedLocale];

const EndOfLifeNote = () => (
  <div>
    <Message info>
      <Message.Header>
        <FormattedMessage id="SUPPLIER_MANAGEMENT_END_OF_LIFE_HEADER" />
      </Message.Header>

      <p>
        <FormattedMessage id="SUPPLIER_MANAGEMENT_END_OF_LIFE_BODY" />
      </p>
    </Message>
  </div>
);

const AppRouter = ({history}) => (
  <IntlProvider messages={messages} locale={selectedLocale} defaultLocale="en">
    <Router history={history}>
      <Layout>
        <Switch>
          <Route path="*" component={EndOfLifeNote} />
        </Switch>
      </Layout>
    </Router>
  </IntlProvider>
);
export {AppRouter, AppLinks};
